import PropTypes from "prop-types"
import { People } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function ResourceTeamsHeader({ account, name }) {
  const resourceName = name ? `Resource Permissions: ${name} ` : "Resource Permissions"
  return <Header Icon={People} title={resourceName} account={account} />
}

ResourceTeamsHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.resourceTeams.data.resource.name") }), null)(ResourceTeamsHeader)
